function getFpFormValue(name) {
	return $('*[name="' + name + '"]').val();
}

function getFpFormInteger(name) {
	let value = getFpFormValue(name);
	return parseInt(value) ? parseInt(value) : 0;
}

function setFpFormValue(name, value) {
	$('*[name="' + name + '"]').val(value);
}

